<script>
import { mapGetters } from 'vuex';
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  props: {
    source: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    dashboardPath() {
      return frontendURL(`accounts/${this.accountId}/dashboard`);
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="dashboardPath"
      class="flex items-center justify-start gap-2"
      replace
    >
      <!-- Sempre sobre fundo escuro (bg-primary-950 no AppSidebar, #002750 no
           MobileHeader), por isso a variante dark. A marca nova traz fonte
           propria para o wordmark, entao a logo horizontal substitui o
           simbolo + texto HTML de antes. Le a config em vez de fixar o
           caminho padrao para respeitar LOGO_DARK customizada por um super
           admin. -->
      <img
        :src="globalConfig.logoDark || globalConfig.logo"
        alt="FlipDesk"
        class="h-8 w-auto"
      />
    </router-link>
  </div>
</template>
